import { useEffect } from 'react'
import { systemService } from '@/services/systemService'
import { mergeThemeKeepingMode, useThemeStore } from '@/stores/themeStore'
import { useAuthStore } from '@/stores/authStore'
import { defaultTheme, withRocketThemeDefaults } from '@/types/theme'

export function useAppBranding() {
  const setTheme = useThemeStore((state) => state.setTheme)
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const authReady = useAuthStore((s) => s.authReady)

  useEffect(() => {
    if (!authReady || !isAuthenticated) return

    async function loadBranding() {
      try {
        const settings = await systemService.getSettings()
        const chosenMode = useThemeStore.getState().theme.mode
        const incoming = settings.theme
          ? { ...defaultTheme, ...settings.theme }
          : {
              ...defaultTheme,
              brandPrimary: settings.primaryColor,
              brandSecondary: settings.secondaryColor,
              companyName: settings.companyName,
              logoUrl: settings.companyLogo,
              logoUrlDark: settings.logoUrlDark,
              logoUrlLight: settings.logoUrlLight,
            }
        setTheme(mergeThemeKeepingMode(withRocketThemeDefaults(incoming), chosenMode))
      } catch (error) {
        if (import.meta.env.DEV) {
          console.debug('Branding not loaded (expected if not logged in):', (error as Error).message)
        }
      }
    }
    void loadBranding()
  }, [setTheme, authReady, isAuthenticated])
}
